import React, { Component, Fragment } from 'react'
import VehicleDetails from '.';

import './VehicleDetails.scss';
class VehicleDetailsItemsInformation extends Component {
	constructor(props) {
		super(props);

		this.state = {
			arrowMoreItems: false,
			listMoreItems: false,
		}
		this.handleClickArrowMoreItems = this.handleClickArrowMoreItems.bind(this);
		this.renderColumnsRowsItemsInformation = this.renderColumnsRowsItemsInformation.bind(this)

	}

	handleClickArrowMoreItems() {
		this.setState({ listMoreItems: !this.state.listMoreItems })
	}
	renderItemsInformation() {
		return (
			<Fragment>
				<div className="VehicleDetails__container__header">
					<h2 className="VehicleDetails__container__header__title">Itens de veículo</h2>
				</div>
				<ul class="VehicleDetails__list VehicleDetails__list--items">
					{this.renderColumnsRowsItemsInformation()}
				</ul>
			</Fragment>
		)
	}
	renderColumnsRowsItemsInformation() {
		let _rows = this.props.optionals.listFormatted.map((option, index) => {
			return (
				<Fragment key={index}>
					<li className={"VehicleDetails__list__item"}>
						<h3 id={'VehicleItemsInformationPos1-' + (index + 1)} className={"VehicleDetails__list__item__value"}>{option.pos1 ? option.pos1.Name : undefined}</h3>
					</li>
					<li className={"VehicleDetails__list__item"}>
						<h3 id={'VehicleItemsInformationPos2-' + (index + 1)} className={"VehicleDetails__list__item__value"}>{option.pos2 ? option.pos2.Name : undefined}</h3>
					</li>
				</Fragment>)
		})
		return _rows
	}
	render() {
		return (
			this.props.optionals.listFormatted && this.props.optionals.listFormatted.length > 0 ?
				<VehicleDetails id={this.props.id ? this.props.id : ''} title={this.props.title ? this.props.title : ''} className={this.props.className ? this.props.className : ''}>
					{this.renderItemsInformation()}
				</VehicleDetails>
				: null
		)
	}
}
export default VehicleDetailsItemsInformation
